import React from 'react';
import './Gallery.css';

const images = [
  '/assets/img1.jpeg',
  '/assets/img2.jpeg',
  '/assets/img3.jpeg',
  '/assets/img4.jpeg',
  '/assets/img5.jpeg',
  '/assets/img7.jpeg',
  '/assets/img8.jpeg',
  '/assets/img10.jpeg',
];

const Gallery = () => {
  return (
    <section className="gallery-section" id="gallery">
      <div className="container text-center">
        <h2 className="gallery-title">GALLERY</h2>
        <p className="gallery-subtitle">
          Glimpse of our healing environment, where transformation begins.
        </p>
        <div className="dot-divider mx-auto"></div>

        <div className="row mt-5">
          {images.map((src, idx) => (
            <div
              className="col-md-3 mb-4 gallery-item"
              key={idx}
              data-aos="zoom-in"
              data-aos-delay={idx * 100}
            >
              <div className="gallery-img-wrapper">
                <img src={src} alt={`Gallery ${idx + 1}`} className="img-fluid" />
                <div className="overlay">
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
